const wsk = {
  page404: {
    title: "Zrejme ste sa stratili",
    message: "Stratili ste sa?",
    action_btn: "Späť na úvod"
  },
  address: {
    title: "Address",
    type: {
      personal: "Súkromná osoba",
      company: "Firma"
    },
    organisation: {
      label: "Názov firmy"
    },
    name: {
      first_name: "Krstné meno",
      last_name: "Priezvisko",
      label: "Kontaktná osoba"
    },
    contact_person: {
      first_name: "Krstné meno",
      last_name: "Priezvisko",
      label: "Kontaktná osoba"
    },
    street: {
      label: "Ulica a číslo",
      address1: "Address 1",
      address2: "Address 2"
    },
    city: {
      label: "Mesto"
    },
    postal_code: {
      label: "PSČ"
    },
    country_code: {
      label: "Krajina"
    },
    company_data: {
      title: "Firemné údaje"
    },
    company_id: {
      label: "IČO"
    },
    tax_id: {
      label: "DIČ"
    },
    vat_id: {
      label: "IČ DPH"
    }
  },
  empty_state: {
    title: "Nič sme nenašli..."
  },
  profile: {
    emails: {
      label: "Email (môžete zadať viac emailov)"
    },
    email: {
      label: "Email"
    },
    phone: {
      label: "Telefón",
      short: "Phone"
    }
  },
  validation: {
    country_required: "Vyplňte krajinu",
    company_id: {
      not_valid: "Neplatné IČO"
    },
    tax_id: {
      not_valid: "Neplatné DIČ"
    },
    vat_id: {
      not_valid: "Neplatné IČ DPH"
    }
  },
  general: {
    back: "Naspäť",
    cancel: "Zrušiť",
    close: "Zavrieť",
    remove: "Odstrániť",
    optional: "nepovinné",
    period: {
      months_one: "{count} mesiac",
      years_one: "{count} rok",
      months_few: "{count} mesiace",
      years_few: "{count} roky",
      months_other: "{count} mesiacov",
      years_other: "{count} rokov",
      explicit: "Obdobie",
      short: {
        months: "{period} mes.",
        years_one: "{count} rok",
        years_few: "{count} roky",
        years_other: "{count} rokov"
      },
      next: {
        months_one: "ďalší mesiac",
        years_one: "ďalší rok",
        months_few: "ďalšie {count} mesiace",
        years_few: "ďalšie {count} roky",
        months_other: "ďalších {count} mesiacov",
        years_other: "ďalších {count} rokov",
        short: {
          months_one: "ďalší mes.",
          years_one: "ďalší rok",
          months_few: "ďalšie {count} mes.",
          years_few: "ďalšie {count} roky",
          months_other: "ďalších {count} mes.",
          years_other: "ďalších {count} rokov"
        }
      },
      per: {
        months_one: "mesačne",
        years_one: "ročne",
        months_few: "na {count} mesiace",
        years_few: "na {count} roky",
        months_other: "na {count} mesiacov",
        years_other: "na {count} rokov",
        short: {
          months_one: "/mes.",
          years_one: "ročne",
          months_few: "/{count} mes.",
          years_few: "na {count} roky",
          months_other: "/{count} mes.",
          years_other: "na {count} rokov"
        }
      }
    },
    or: "alebo",
    recommended: "odporúčame",
    settings: "Nastavenia",
    edit: "Upraviť",
    save: "Uložiť",
    save_changes: "Uložiť",
    reset_form: "Obnoviť formulár",
    not_available: "Nedostupné",
    unknown_error: "Neznáma chyba",
    unknown_error_id: "Neznáma chyba ({id})",
    something_went_wrong: "Ospravedlňujeme sa za neočakávaný výsledok. Niečo sa pokazilo.",
    link: "odkaz",
    buy: "Kúpiť"
  },
  capslock_hint: {
    line1: "Caps Lock",
    line2: "je zapnutý"
  },
  ws_password_input: {
    expose_password: "Zobraziť heslo"
  },
  ws_array_input: {
    incorrect_email: "Nesprávna emailová adresa(y)",
    incorrect_web: "Nesprávna webová adresa (adresy)",
    some_filtered: "Tento reťazec nie je možné spracovať."
  },
  ws_places_input: {
    no_results: "Hľadané miesto nebolo nájdené, skúste menej špecifickú adresu"
  },
  ws_uploader: {
    validation: {
      file_type: "Nesprávny typ súboru.",
      file_size: "Veľkosť súboru prekročila limit ({limit})"
    },
    status: {
      label: "Stav",
      value: {
        uploaded: "nahraté",
        uploading: "nahrávam",
        failed: "zlyhané",
        idle: "idle"
      }
    },
    action: {
      title: "Nahrajte faktúry",
      text1: "Presuňte súbor alebo",
      link: "vyberte",
      text2: ".",
      abort_tooltip: "Zrušiť nahrávanie"
    },
    supported_file_types: "Podporované typy súborov:",
    remove_btn: "Odstrániť"
  },
  ws_table: {
    filter: {
      fulltext_title: "Fulltext vyhľadávanie",
      data_title: "Vyhľadávanie",
      clear_filters: "Vymazať všetky filtre",
      from: "Od",
      to: "Do"
    },
    label: {
      bulk_actions: "Hromadné akcie",
      cancel_selection: "Zrušiť výber",
      item_selected: "vybratých položiek",
      selected: "Vybratých",
      filterby: "Triediť podľa",
      records_per_page: "Záznamy na stránku:",
      select_all: "Vybrať všetko"
    }
  },
  ws_password_strength: {
    rule1: "Minimálne 8 znakov",
    rule2: "Minimálne 1 veľké a 1 malé písmeno",
    rule3: "Minimálne 1 číslo",
    rule4: "Minimálne 1 špeciálny znak"
  },
  ws_password_confirmation_input: {
    passwords_do_not_match: "Heslá sa nezhodujú!"
  },
  ws_two_factor_authentication_input: {
    on_cooldown_one: "Kód môžete znova odoslať o {{count}} sekundu.",
    on_cooldown_few: "Kód môžete znova odoslať o {count} sekúnd.",
    on_cooldown_other: "Kód môžete znova odoslať o {{count}} sekúnd.",
    resend_code: "Znova odoslať kód",
    code_being_sent: "Odosielanie 2FA kódu...",
    code_sent_successfully: "2FA kód bol úspešne odoslaný",
    error_sending_code: "Chyba pri odosielaní 2FA kódu",
    invalid_code_pasted: "Bol zadaný neplatný kód pre dvojfaktorovú autentifikáciu. Prosím zadajte správny kód."
  },
  generate_random: "Generuj náhodné",
  copy: {
    copy: "Skopírovať",
    copied: "Skopírované",
    saved_in_clipboard: "Skopírované"
  },
  out_modal: {
    title: "Váš prehliadač nie je aktualizovaný.",
    text: "Prosím, aktualizujte prehliadač alebo použite iný.",
    delimiter_text: "Môžeme pomôcť"
  },
  buttons: {
    ok_thanks: "Ok, Thanks"
  },
  payment_cards: {
    ending_with: "Ending with",
    active: "Active",
    issued_by: "Vydavateľ karty: {issuer}."
  },
  ws_sub_items_price_summary: {
    current_price: "Cena za službu (aktuálne obdobie)",
    due_now: "Splatné ihneď",
    next_period_subtraction_warning: "* Suma bude odpočítaná v nasledujúcom fakturačnom období.",
    next_price: "Cena za službu (ďalšie obdobie)"
  },
  dialog_footer: {
    cannot_submit_empty_form: "It is not possible to submit an empty form."
  },
  price_badge: {
    including_vat: "(s DPH)",
    excluding_vat: "(bez DPH)"
  },
  cart_item: {
    notices: {
      business_mail: {
        license_count_increase: {
          title: "Vaša doména už má aktívne mailboxy.",
          text_one: "Aktuálne máte {count} e-mailovú schránku na tejto doméne. Pre migráciu na Biznis Mail je potrebné do objednávky pridať minimálne rovnaký počet licencií.",
          text_few: "Aktuálne máte {count} e-mailové schránky na tejto doméne. Pre migráciu na Biznis Mail je potrebné do objednávky pridať minimálne rovnaký počet licencií.",
          text_other: "Aktuálne máte {count} e-mailových schránok na tejto doméne. Pre migráciu na Biznis Mail je potrebné do objednávky pridať minimálne rovnaký počet licencií."
        },
        free_trial: {
          title: "Začnite svoju 60-dňovú bezplatnú skúšobnú verziu ešte dnes!",
          text: "Pre každú službu Biznis Mail je automaticky aktivovaná bezplatná skúšobná verzia, v rámci ktorej môžete otestovať najvyššiu Premium licenciu."
        },
        free_trial_postfix: {
          title: "Začnite svoju 60-dňovú bezplatnú skúšobnú verziu ešte dnes!",
          text_one: "Pre všetky vaše hostingové e-mailové schránky, ktoré migrujeme, sa automaticky aktivuje bezplatná skúšobná verzia, v rámci ktorej môžete otestovať najvyššiu Premium licenciu. Pre jej využitie je potrebné do objednávky pridať minimálne taký počet Premium licencií, koľko e-mailových schránok sa migruje (Máte 1 e-mailovú schránku). <b>Migrácia môže ovplyvniť obsah schránky (kontakty/kalendáre) preto pred objednávkou odporúčame si preštudovať <a href='https://www.websupport.sk/podpora/kb/migracia-emailov-na-biznis-mail/' target='_blank'> ako funguje proces migrácie na Biznis Mail</a>.</b>",
          text_few: "Pre všetky vaše hostingové e-mailové schránky, ktoré migrujeme, sa automaticky aktivuje bezplatná skúšobná verzia, v rámci ktorej môžete otestovať najvyššiu Premium licenciu. Pre jej využitie je potrebné do objednávky pridať minimálne taký počet Premium licencií, koľko e-mailových schránok sa migruje (Máte {count} e-mailové schránky). <b>Migrácia môže ovplyvniť obsah schránky (kontakty/kalendáre) preto pred objednávkou odporúčame si preštudovať <a href='https://www.websupport.sk/podpora/kb/migracia-emailov-na-biznis-mail/' target='_blank'> ako funguje proces migrácie na Biznis Mail</a>.</b>",
          text_other: "Pre všetky vaše hostingové e-mailové schránky, ktoré migrujeme, sa automaticky aktivuje bezplatná skúšobná verzia, v rámci ktorej môžete otestovať najvyššiu Premium licenciu. Pre jej využitie je potrebné do objednávky pridať minimálne taký počet Premium licencií, koľko e-mailových schránok sa migruje (Máte {count} e-mailových schránok). <b>Migrácia môže ovplyvniť obsah schránky (kontakty/kalendáre) preto pred objednávkou odporúčame si preštudovať <a href='https://www.websupport.sk/podpora/kb/migracia-emailov-na-biznis-mail/' target='_blank'> ako funguje proces migrácie na Biznis Mail</a>.</b>"
        },
        free_trial_premium_licenses_notice: {
          title_one: "Pre migráciu na Business Mail potrebujete minimálne 1 Premium licenciu",
          title_few: "Pre migráciu na Business Mail potrebujete minimálne {count} Premium licencie",
          title_other: "Pre migráciu na Business Mail potrebujete minimálne {count} Premium licencií",
          text: "Aby sme vám to uľahčili, automaticky sme vám potrebný počet Premium licencií pridali, pokiaľ ste tak neurobili v predošlom kroku. \n<b>Migrácia môže ovplyvniť obsah schránky (kontakty/kalendáre) preto pred objednávkou odporúčame si preštudovať <a href='https://www.websupport.sk/podpora/kb/migracia-emailov-na-biznis-mail/' target='_blank'>ako funguje proces migrácie na Biznis Mail</a>.</b>\n"
        }
      }
    }
  },
  login_pages: {
    footer: {
      help: "Pomoc",
      terms: "Podmienky",
      privacy: "Súkromie"
    },
    help: {
      title: "Potrebujete poradiť?",
      text: "Pozrite sa do našej  <a href='{kb_url}' target='_blank'>bázy znalostí</a>. Ak nenájdete odpoveď na vašu otázku, neváhajte kontaktovať našu  <a href='{support_url}' target='_blank'>podporu</a>."
    }
  },
  message_service: {
    error: {
      axios: {
        title: "Network Error",
        text: "Unable to connect"
      },
      status_401: {
        text: "You don't have the required permissions."
      },
      status_403: {
        text: "Access denied."
      },
      status_404: {
        text: "Source not found."
      },
      status_407: {
        text: "Please login via the Legacy Active24 login page."
      },
      status_408: {
        text: "Connection timeout."
      },
      status_500: {
        text: "Uh oh, something went wrong. Please contact our support."
      },
      unexpected: {
        title: "Error",
        text: "Unexpected error"
      }
    }
  },
  ws_input: {
    invalid_phone_number: "Neplatné telefónne číslo",
    phone_missing: "Telefónne číslo je povinné"
  },
  ws_google_autocomplete: {
    no_results: "Hľadané miesto nebolo nájdené, skúste menej špecifickú adresu"
  }
};
const wsk_skSK = {
  wsk
};
export {
  wsk_skSK as default,
  wsk
};
//# sourceMappingURL=wsk.sk-SK.json.es.js.map
